import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /accessibility.
 *
 * The legacy page's four sections were already `<h2>`s under the H1, so they are the
 * cards' headings here unchanged, as on MagSpot. The words are unchanged.
 */
export default function Accessibility() {
  return (
    <>
      <Breadcrumbs
        items={[{ label: 'Home', href: '/' }, { label: 'Website Accessibility Statement' }]}
      />

      <PageHeading eyebrow="Customer Information">Website Accessibility Statement</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <h2>General Policy</h2>
          <p>
            MagZoom.com is committed to facilitating the accessibility and usability of its website
            for all people with disabilities. We are implementing the relevant portions of the World
            Wide Web Consortium&rsquo;s Web Content Accessibility Guidelines 2.1 Level AA (WCAG 2.1
            AA) as our web accessibility standard.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Current Status</h2>
          <p>
            Our security and development teams are currently conducting periodic accessibility
            audits of our web pages. These audits allow us to identify and address barriers to
            access. Please note that our website may link to third-party providers or use
            third-party add-ons; we cannot always control the accessibility standards of these
            outside entities, though we encourage them to provide content that is accessible and
            user-friendly.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Disclaimer</h2>
          <p>
            Our efforts to maintain accessibility and usability are ongoing. While we strive to make
            the website as accessible as possible, some issues may be encountered by different
            assistive technologies as the range of available tools is wide and varied.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Accessibility Support</h2>
          {/*
           * No bottom margin: this paragraph runs straight into the list it introduces,
           * which is what the legacy page's inline `margin-bottom: 0` did. `mb-0` rather
           * than `m-0` — inside prose only the longhands are raised to !important, so the
           * shorthand loses to the top margin. See PR #1816.
           */}
          <p className="mb-0">
            If you have specific questions or concerns about the accessibility of any particular web
            page on MagZoom.com, please contact us. If you encounter an accessibility issue, please
            specify the web page URL in your email so we can make all reasonable efforts to make
            that page accessible for you.
          </p>
          <ul>
            <li>
              <strong>Phone:</strong> 1-877-755-0062
            </li>
            <li>
              <strong>Email:</strong> <a href="mailto:service@magzoom.com">service@magzoom.com</a>
            </li>
          </ul>
        </ContentCard>
      </div>
    </>
  );
}

Accessibility.layoutName = 'Layouts.Institutional';
